<template>
  <div class="modal-mandatory-comments">
    <h2>
      {{ options.title }}
    </h2>
    <div v-if="mandatoryComment" class="modal-mandatory-comments__content">
      <oie-mandatory-comments v-model="mandatoryComment"></oie-mandatory-comments>
      <oie-action-wrapper>
        <oie-base-action size="large" theme="skeleton" @click="close">
          {{ tStatic('modalCancel') }}
        </oie-base-action>
        <oie-base-action size="large" :disabled="!canPlaceItem" @click="options.addComments(mandatoryComment)">
          {{ tStatic('confirmCommentLabel') }}
        </oie-base-action>
      </oie-action-wrapper>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      mandatoryComment: null
    }
  },
  computed: {
    canPlaceItem() {
      return _.chain(this.mandatoryComment).flatMap(val => val).every(comment => comment.value).value()
    }
  },
  mounted() {
    this.mandatoryComment = _.cloneDeep(this.options.mandatoryComment)
  },
  methods: {
    close() {
      this.publish('modal.hide.mandatory-comments')
    }
  }
}
</script>

<style lang="scss">
.modal-mandatory-comments > *:not(:last-child),
.modal-mandatory-comments__content > *:not(:last-child) {
    margin-bottom: measure(full);
}
</style>
